import { render, staticRenderFns } from "./dialogFace.vue?vue&type=template&id=0f17da3a&scoped=true"
import script from "./dialogFace.vue?vue&type=script&lang=js"
export * from "./dialogFace.vue?vue&type=script&lang=js"
import style0 from "./dialogFace.vue?vue&type=style&index=0&id=0f17da3a&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f17da3a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\App_php\\cqjtdx\\cqjtdx_student\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f17da3a')) {
      api.createRecord('0f17da3a', component.options)
    } else {
      api.reload('0f17da3a', component.options)
    }
    module.hot.accept("./dialogFace.vue?vue&type=template&id=0f17da3a&scoped=true", function () {
      api.rerender('0f17da3a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/layout/templateModule/dialogFace.vue"
export default component.exports